/** The first human-readable string in a DRF error body.
 *
 * `utils/handlers/get-response-message.ts` covers the flat shapes; this one
 * recurses, because a `many=True` serializer answers with a list of per-row
 * objects and the message can sit arbitrarily deep inside it.
 */
const firstErrorMessage = (value: unknown): string | undefined => {
  if (typeof value === "string") return value
  if (Array.isArray(value)) {
    for (const item of value) {
      const found = firstErrorMessage(item)
      if (found) return found
    }
    return undefined
  }
  if (value && typeof value === "object") {
    for (const item of Object.values(value)) {
      const found = firstErrorMessage(item)
      if (found) return found
    }
  }
  return undefined
}

export const readSettingsError = (data: unknown): string => {
  const details = (data as { details?: { message?: string } })?.details
  if (details?.message) return details.message
  return firstErrorMessage(data) ?? ""
}
